import { render, staticRenderFns } from "./AddDualAxisBarTrendWidget.vue?vue&type=template&id=207f1bd9"
import script from "./AddDualAxisBarTrendWidget.vue?vue&type=script&lang=js"
export * from "./AddDualAxisBarTrendWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports